<router-outlet />
<div class="container-xxl py-5">
  <div class="container">
    <!-- Stages Brief Start -->
    <div id="STAGES_SECTION" class="row g-5 align-items-center">
      <div class="col-lg-11 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">  {{ BAC_ACADEMIC_DATA.stages.title[language] }}</h1>
        <p>
          {{ BAC_ACADEMIC_DATA.stages.description[language] }}
        </p>
      </div>
      <div class="row g-4 center-content">
        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
          <a href="/academics/stages/elementary">
            <div class="facility-item">
              <div class="facility-text bg-primary">
                <h3 class="text-primary mb-3">
                  {{ "elementary" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
          <a href="/academics/stages/college">
            <div class="facility-item">
              <div class="facility-text bg-success">
                <h3 class="text-success mb-3">
                  {{ "college" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
          <a href="/academics/stages/lycee">
            <div class="facility-item">
              <div class="facility-text bg-warning">
                <h3 class="text-warning mb-3">
                  {{ "lycee" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- Stages Brief End -->
    <br />
    <br />
    <br />
    <!-- Library Brief Start -->
    <div id="LIBRARY_SECTION" class="row g-5 align-items-center">
      <h1 class="mb-4">{{ BAC_ACADEMIC_DATA.library.brief.title[language] }}</h1>
      <div class="bg-light rounded">
        <div class="row g-0">
          <div
            class="col-lg-6 wow fadeIn"
            data-wow-delay="0.1s"
            style="min-height: 400px"
          >
            <div class="position-relative h-100">
              <img
                class="position-absolute w-100 h-100 rounded"
                src="../../../assets/img/{{ BAC_ACADEMIC_DATA.library.brief.image }}"
                style="object-fit: cover"
              />
            </div>
          </div>
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div class="h-100 d-flex flex-column justify-content-center p-5">
              <p class="mb-4">
                {{ BAC_ACADEMIC_DATA.library.brief.description[language] }}
              </p>
              <a class="btn btn-primary py-3 px-5" href="/academics/library">{{
                "go_to_library" | translate
              }}</a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Library Brief End -->
  </div>
</div>
